import Header from './components/Header';
import Hero from './components/Hero';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import FAQSection from './components/FAQSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <CommentsSection />
        <CarouselSection />
        <UpdatesSection />
        <AboutSection />
        <RankingSection />
        <MediaSection />
        <ContactSection />
        <IndexSection />
        <TopicsSection />
        <CardsSection />
        <FeaturesSection />
        <FAQSection />
        <AppSection />
      </main>
      <Footer />
    </div>
  );
}